import { registerTacticalPlugin } from "./registry";

registerTacticalPlugin({
  id: "los",
  label: "Прямая видимость",
  description: "Два клика: наблюдатель → цель (встроенный LOS).",
  activate: (host) => {
    host.setLosMode?.(true);
    return () => host.setLosMode?.(false);
  },
});
